/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Add_User_SuccessInputs */



/**
* | output |
* | --- |
* | "User added to space successfully!" |
*
* @param {Spaces_Add_User_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_add_user_success = /** @type {((inputs?: Spaces_Add_User_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Add_User_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Benutzer erfolgreich zum Speicherplatz hinzugefügt!")
	return /** @type {LocalizedString} */ ("User added to space successfully!")
});